<template>
  <div>
    <v-menu v-model="displayDropdown" transition="slide-y-transition" :close-on-content-click="false" eager>
      <template #activator="{ on, attrs }">
        <slot name="activator">
          <v-btn color="primary" v-bind="attrs" v-on="on">
            Выбор Фото
          </v-btn>
        </slot>
      </template>

      <div class="bucket-file-input__content">
        <image-uploader :bucket="bucket" small @change="addimage" @close="displayDropdown = false" />
      </div>
    </v-menu>
    <div v-if="!noPreview" class="bucket-file-input__previews my-5">
      <draggable v-model="files" draggable=".item" @end="repositon">
        <div v-for="(image, index) in files" :key="index" class="item">
          <div>
            <v-icon small @click="deleteImage(index)">
              mdi-close-octagon
            </v-icon>
          </div>
          <v-img
            :src="geturl(image)"
            :height="previewHeight"
            :width="previewWidth"
            class="mb-2 mx-2"
            contain
          />
          <v-text-field v-model="image.alt" label="Альтернативный текст" />
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
 import ImageUploader from '@/components/core/ImageUploader/ImageUploader'
 import draggable from 'vuedraggable'
export default {
  name: 'FileInput',
 components: { ImageUploader, draggable },
  model: {
    event: 'change'
  },
  props: {
    bucket: {
      type: String,
      required: true
    },
    value: {
      type: [Array, Object],
      required: true
    },
    noPreview: {
      type: Boolean
    },
    previewWidth: {
      type: [Number, String],
      default: 200
    },
    previewHeight: {
      type: [Number, String],
      default: 200
    }
  },
  data () {
    return {
      displayDropdown: false
    }
  },
  computed: {
    files: {
      get () {
        return this?.value || []
      },
      set (value) {
        this.displayDropdown = false
        this.$emit('change', value)
      }
    }
  },
  // watch: {
    // value (items) {
    //   this.files = []
    //   items.forEach((item) => {
    //     this.files.push(item.file)
    //   })
    // }
  // },
  methods: {
    deleteImage (index) {
      this.files.splice(index, 1)
    },
    repositon () {
      this.files.forEach((item, index) => {
        item.position = index
      })
    },
    geturl (item) {
      return item?.file?.url
    },
    addimage (images) {
      // images.forEach((item) => {
      //   this.files.push({
      //     alt: '',
      //     position: this.files.length,
      //     file: item
      //   })
      // })
      let prevFiles = []
      let position = 0
      if (this?.files) {
        prevFiles = this.files
        position = this.files.length
      }

      prevFiles.push({
        alt: '',
        position,
        file: {
          key: images.key,
          url: images.url
        }
      })
      this.files = prevFiles
    }
  }
}
</script>

<style lang="sass">
  @use "~/assets/sass/core/variables.sass" as vars
  .bucket-file-input__content
    background-color: vars.$color-white
    height: 600px
    width: 40vw

  .bucket-file-input__previews
    overflow-x: auto

    > *
      display: flex
  .mdi-close-octagon::before
    color: crimson

</style>
